import PageHero from "../components/PageHero";
import AudienceGrid from "../components/sections/AudienceGrid";
import TrustStats from "../components/sections/TrustStats";
import Marquee from "../components/shared/Marquee";
import BusinessIntro from "../components/sections/BusinessIntro";
import Manifesto from "../components/sections/Manifesto";
import FeaturedServices from "../components/sections/FeaturedServices";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import Process from "../components/sections/Process";
import VideosSection from "../components/sections/VideosSection";
import BeforeAfterGallery from "../components/sections/BeforeAfterGallery";
import PhotoGallery from "../components/sections/PhotoGallery";
import GoogleReviews from "../components/sections/GoogleReviews";
import BlogPreview from "../components/sections/BlogPreview";
import FaqPreview from "../components/sections/FaqPreview";
import FinalCTA from "../components/sections/FinalCTA";
import { FAQ_PREVIEW } from "../data/faqs";

const MARQUEE_ITEMS = [
  "Residential",
  "Commercial",
  "Post-Renovation",
  "End of Tenancy",
  "Deep Floor",
  "Sofa & Mattress",
  "Pressure Washing",
];

export default function Home() {
  return (
    <>
      {/*
        The homepage uses the same hero as every other page, at the client's
        request — headline and reassurance points on the left, a short quote
        form on the right. One component means the quote form cannot drift out
        of step between the homepage and the service pages.
      */}
      <PageHero
        eyebrow="One of Singapore's fastest growing cleaning companies"
        headline={"Professional Cleaning.\nExceptional Results."}
        intro="From post-renovation to disinfection, we deliver spotless results for a healthier and cleaner space across Singapore."
        image="/generated/hero_home.png"
        imageAlt="Emilio's Solutions cleaner working in a Singapore property"
      />
      <TrustStats />
      <AudienceGrid />
      <Marquee items={MARQUEE_ITEMS} />
      <BusinessIntro />
      <Manifesto />
      <FeaturedServices />
      <WhyChooseUs />
      <Process />
      <VideosSection />
      <BeforeAfterGallery />
      <PhotoGallery limit={6} showFilters={false} />
      {/*
        No promotions section here by request: promotions are reachable from
        the footer only. The page and admin screen stay live, and the contact
        form still lets a customer name the promotion they are asking about,
        so campaigns keep working as a lead source.
      */}
      <GoogleReviews />
      <BlogPreview />
      <FaqPreview items={FAQ_PREVIEW} />
      <FinalCTA />
    </>
  );
}
